import React, { Component } from 'react'

import ServiceCalc from './ServiceCalc'


class ServiceCriteria extends Component {

	constructor(props) {
		super(props);
		this.onChange = props.onChange;
		this.theme = props.theme;
	}

	handleServiceChange = (code, checked) => {
		var svcMap = this.props.svcMap;
		var svcElt = this.props.svcMap[code];
		if (svcElt != null) {
			svcElt.selected = checked;
			svcMap[code] = svcElt;
		}
		this.onChange(svcMap);
	}

	render() {
		return (
			<ul className="list-group list-group-flush">
				{this.props.packagesData != null && this.props.packagesData.map((service, index) => (
					<ServiceCalc
						code={service.packageCode}
						label={service.label}
						info={service.description}
						mandatory={service.mandatory}
						subServices={service.services}
						selected={this.props.svcMap[service.packageCode].selected}
						mapSelected={this.props.svcMap}
						key={index}
						onChange={this.handleServiceChange}
						level={1}
						theme={this.theme}
						selectable={this.props.svcMap[service.packageCode].selectable}
					/>
				))}
				{this.props.servicesData != null && this.props.servicesData.map((service, index) => (
					<ServiceCalc
						code={service.serviceCode}
						label={service.label}
						info={service.description}
						mandatory={service.mandatory}
						selected={this.props.svcMap[service.serviceCode].selected}
						mapSelected={this.props.svcMap}
						key={index}
						onChange={this.handleServiceChange}
						level={1}
						theme={this.theme}
						selectable={this.props.svcMap[service.serviceCode].selectable}
					/>
				))}
			</ul>
		)
	}
}

export default (ServiceCriteria)
